import React from "react";
import HeroSlider from "../../Component/HeroSlider";
import ServiceSectionHome from "../../Component/ServiceCMPT/ServiceSectionHome";
import AboutSectionHome from "../../Component/AboutCMPT/AboutSectionHome";
import ProjectSectionHome from "../../Component/ProjectCMPT/ProjectSectionHome";
import BlogSectionHome from "../../Component/BlogsCMPT/BlogSectionHome";
import ContactSectionHome from "../../Component/ContactCMPT/ContactSectionHome";
import HouseOffer from "../../Component/HouseOffer";
import HomeMetaData from "../../Utils/HomeMetaData";
import CounterSection from "../../Component/CounterSection";

export default function Home() {
  return (
    <>
      <HomeMetaData />
      {/* Hero Slider  */}
      <HeroSlider />

      {/* About Us  */}
      <AboutSectionHome />

      <CounterSection />

      {/* Services  */}
      <ServiceSectionHome />

      {/* OUR LIST OF PROJECT */}
      <ProjectSectionHome />

      {/* HouseOffer Section Start */}
      <HouseOffer />

      {/* Latest Blogs */}
      <BlogSectionHome />

      {/* Contact Section  */}
      <ContactSectionHome />
    </>
  );
}
